module.exports = __webpack_public_path__ + "static/media/estateImoveisDesconto.c32cd1e1.png";